const VALID_VENDOR_SEARCH_JOB_NAMES = {
  START_VENDOR_REGEX_SEARCH: "startVendorRegexSearch",
  START_MEMO_TESTER: "startMemoTester"
};
const VALID_SITE_CRAWLER_JOB_NAMES = {
  START_CRAWLING_SITE: "startCrawlingSite",
  SCRAPE_ALL_PAGES: "scrapeAllPages",
  SCRAPE_SINGLE_PAGE: "scrapeSinglePage",
  START_ANALYZING_SITE: "startAnalyzingSite",
  ANALYZE_ALL_PAGES: "analyzeAllPages",
  ANALYZE_SINGLE_PAGE: "analyzeSinglePage",
  CRAWL_AND_EMBED_SITE: "crawlAndEmbedSite"
};
const VALID_BRAND_RATINGS_JOB_NAMES = {
  PROCESS_BRAND_RATING: "processBrandRating"
};
const VALID_GDPR_EXPORT_JOB_NAMES = {
  RUN_GDPR_EXPORT: "runGdprExport"
};

module.exports = {
  VALID_VENDOR_SEARCH_JOB_NAMES,
  VALID_SITE_CRAWLER_JOB_NAMES,
  VALID_BRAND_RATINGS_JOB_NAMES,
  VALID_GDPR_EXPORT_JOB_NAMES
};
